import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {supplierSpendTrendUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierSpendTrend} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * Monthly spend for one entity, this year vs last (`GET supplier_360/entity/{id}/spend_trend/`).
 * A plain aggregate action, not a paginated list — the response is the object itself.
 */
export function useSupplierSpendTrendQuery(entityId: number | undefined) {
    const url = supplierSpendTrendUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<SupplierSpendTrend>(url)).data,
        enabled: Boolean(entityId),
    });
}
